<template>
  <table class="resource-table">
    <thead>
      <tr>
        <th class="column-number">번호</th>
        <th class="column-title">제목</th>
        <th class="column-author">작성자</th>
        <th class="column-date">작성일</th>
        <th v-if="admin" class="column-actions">관리</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!sortedResources || sortedResources.length === 0">
        <td colspan="5">자료가 없습니다.</td>
      </tr>
      <tr v-for="(resource, index) in resources" :key="resource.id">
        <td class="column-number">
          {{ total - ((currentPage - 1) * perPage + index) }}
        </td>

        <td class="column-title">
          <router-link :to="{ name: 'ResourceDetail', params: { id: resource.id } }">
            {{ resource.title }}
          </router-link>
        </td>
        <td class="column-author">관리자</td>
        <td class="column-date">{{ formatDate(resource.createdAt) }}</td>
        <td v-if="admin" class="column-actions">
          <button class="edit-delete-button" @click="$emit('edit', resource)">수정</button>
          <button class="edit-delete-button" @click="$emit('delete', resource.id)">삭제</button>
        </td>
      </tr>

    </tbody>
  </table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  resources: Array,
  admin: {
    type: Boolean,
    default: false,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  perPage: {
    type: Number,
    required: true,
  },
  total: { type: Number, required: true },  // ★ 추가!
});

const sortedResources = computed(() => {
  if (!props.resources) return [];
  // id를 Number로 명확하게 변환 후 내림차순 정렬
  return [...props.resources].sort((a, b) => Number(b.id) - Number(a.id));
});

// 날짜 포맷
const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
</script>

<style scoped>
.resource-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  table-layout: fixed;
}

.resource-table th,
.resource-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  overflow: hidden;
  text-align: center !important;
  vertical-align: middle;
}

.resource-table th {
  background-color: #f6f6f6;
  text-align: center;
}

.column-number {
  width: 60px;
  max-width: 60px;
  text-align: center;
}

.column-author {
  width: 100px;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.column-title {
  width: 100%;
  min-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 15px;
  text-align: left !important;   /* ← 이 줄 추가 */
}


.resource-table td.column-title {
  text-align: left !important;
  padding-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
}


.column-date {
  width: 120px;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.column-actions {
  width: 120px;
  max-width: 120px;
  text-align: center;
}

.resource-table a {
  text-decoration: none;
  color: #333;
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resource-table a:hover {
  text-decoration: underline;
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: nowrap;
}

.edit-delete-button {
  padding: 6px 10px;
  font-size: 0.85rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}
.edit-delete-button:hover {
  background-color: #0056b3;
}

/* 모바일 대응 */
@media (max-width: 768px) {
  .resource-table {
    font-size: 0.85rem;
  }
  .resource-table th,
  .resource-table td {
    padding: 8px 4px;
  }
  .column-number {
    width: 50px;
    max-width: 50px;
  }
  .column-author {
    width: 60px;
    max-width: 60px;
  }
  .column-date {
    width: 70px;
    max-width: 70px;
  }
  .column-title {
    min-width: 50%;
  }
  .column-actions {
    width: 100px;
    max-width: 100px;
  }
  .edit-delete-button {
    font-size: 0.75rem;
    padding: 4px 6px;
  }
}

@media (max-width: 480px) {
  .column-number {
    width: 50px;
    max-width: 50px;
  }
  .column-author {
    width: 50px;
    max-width: 50px;
  }
  .column-date {
    width: 60px;
    max-width: 60px;
  }
}
</style>
